import type { FC, ReactNode } from 'react';
import './FormInputError.css';
import classNames from 'classnames';

export interface FormInputErrorProps {
  className?: string;
  error?: string;
  renderError?: (error: string) => ReactNode | string;
}

/**
 * Reusable input error component. It behaves as bottom spacing of input so single line error message
 * won't shift form vertically
 */
export const FormInputError: FC<FormInputErrorProps> = (props) => (
  <div className={classNames('form-input-error', props.className)}>
    {props.error && (
      <>
        <i className='fa fa-exclamation-circle form-input-error__icon' />
        <span className='form-input-error__message'>
          {props.renderError ? props.renderError(props.error) : props.error}
        </span>
      </>
    )}
  </div>
);
